export default __webpack_public_path__ + "static/media/media-img-2.5a0c2447.png";